import {
    request,
    requestPublic
} from './request.js'
// 获取全部专题列表 --专题管理
export function getAllSpecialTopic(name) {
    return request({
        url: '/api2/ZsbSiteAdmin/SpecialTopic/GetAllSpecialTopic',
        method: 'get',
        params: {
            Name: name
        }
    })
}
//获取专题详情
export function getSpecialTopicDetail(id) {
    return request({
        url: '/api2/GetSpecialTopicDetail',
        method: 'get',
        params: {
            id: id
        }
    })
}
// 添加专题
export function addSpecialTopic(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SpecialTopic/AddSpecialTopic',
        method: 'post',
        data: data
    })
}
// 修改专题
export function modifySpecialTopic(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SpecialTopic/ModifySpecialTopic',
        method: 'post',
        data: data
    })
}
//删除专题
export function removeSpecialTopic(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/SpecialTopic/RemoveSpecialTopic?id=' + id,
        method: 'post',
    })
}